import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.cashapp_recipient,
    props.app.cashapp_order,
    props.app.buttons.cashapp_create_button,
    (cashapp_recipient, cashapp_order, button) => {
        return {
            cashapp_recipient,
            cashapp_order,
            button
        }
    }
)